var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { CreditScoreUpdate, ShowButtons } from "../store/actions";
import { useSelector, useDispatch } from "react-redux";
import { UserSession } from 'usersession';

import imgExcellent from '../assets/excellent.png';
import imgVeryGood from '../assets/verry_good.png';
import imgGood from '../assets/good.png';
import imgFair from '../assets/fair.png';
import imgPoor from '../assets/poor.png';

var scrollToRef = function scrollToRef(ref) {
    return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function
export default function CreditScore() {
    var userSession = new UserSession();

    var _useState = useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        CreditScore = _useState2[0],
        setCreditScore = _useState2[1];

    var dispatch = useDispatch();
    var creditScoreRedux = useSelector(function (state) {
        return state.nameReducer.CreditScore;
    });

    var myRefCS = useRef(null);

    useEffect(function () {
        //This function scroll the slider into view
        !localStorage.getItem('doNotScroll') && scrollToRef(myRefCS);
    }, []);
    useEffect(function () {
        dispatch(ShowButtons(false));

        setCreditScore(creditScoreRedux);

        userSession.setCreditScore(creditScoreRedux);

        if (CreditScore.length > 0) dispatch(ShowButtons(true));
    }, [CreditScore]);

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Row,
            { className: 'd-flex justify-content-center' },
            React.createElement(
                Col,
                { lg: 12, className: 'text-center mb-4' },
                React.createElement(
                    'h2',
                    null,
                    'Estimate Your Credit Score'
                )
            ),
            React.createElement(
                Form.Group,
                { className: 'mb-0' },
                React.createElement(
                    Form.Row,
                    { className: 'pt-1 d-flex justify-content-center' },
                    React.createElement(
                        Col,
                        { ref: myRefCS, lg: 4, className: 'mb-4' },
                        React.createElement(
                            'div',
                            { className: 'overlay' },
                            React.createElement(Form.Check, {
                                type: 'radio',
                                inline: true,
                                id: 'Excellent',
                                name: 'CreditScore',
                                value: 'Excellent',
                                'aria-label': 'Excellent',
                                label: 'Excellent',
                                checked: CreditScore === "Excellent",
                                onChange: function onChange(e) {
                                    setCreditScore(e.target.value);
                                    dispatch(CreditScoreUpdate(e.target.value));
                                } }),
                            React.createElement('img', { src: imgExcellent,
                                alt: 'Excellent Score',
                                className: 'radImg2 rounded_circle radImg customShadow \n                                    ' + (CreditScore === "Excellent" ? "d-none" : "") })
                        ),
                        React.createElement(
                            'h5',
                            null,
                            'Excellent >= 740'
                        )
                    ),
                    React.createElement(
                        Col,
                        { lg: 4, className: 'mb-4' },
                        React.createElement(
                            'div',
                            { className: 'overlay' },
                            React.createElement(Form.Check, {
                                type: 'radio',
                                inline: true,
                                id: 'VERYGOOD',
                                name: 'CreditScore',
                                value: 'VERYGOOD',
                                'aria-label': 'Very Good',
                                label: 'Very Good',
                                checked: CreditScore === "VERYGOOD",
                                onChange: function onChange(e) {
                                    setCreditScore(e.target.value);
                                    dispatch(CreditScoreUpdate(e.target.value));
                                } }),
                            React.createElement('img', { src: imgVeryGood,
                                alt: 'Very Good Score',
                                className: 'radImg2 rounded_circle radImg customShadow \n                                    ' + (CreditScore === "VERYGOOD" ? "d-none" : "") })
                        ),
                        React.createElement(
                            'h5',
                            null,
                            'Very Good 720-739'
                        )
                    ),
                    React.createElement(
                        Col,
                        { lg: 4, className: 'mb-4' },
                        React.createElement(
                            'div',
                            { className: 'overlay' },
                            React.createElement(Form.Check, {
                                type: 'radio',
                                inline: true,
                                id: 'GOOD',
                                name: 'CreditScore',
                                value: 'GOOD',
                                'aria-label': 'Good',
                                label: 'GOOD',
                                checked: CreditScore === "GOOD",
                                onChange: function onChange(e) {
                                    setCreditScore(e.target.value);
                                    dispatch(CreditScoreUpdate(e.target.value));
                                } }),
                            React.createElement('img', { src: imgGood,
                                alt: 'Good Score',
                                className: 'radImg2 rounded_circle radImg customShadow \n                                    ' + (CreditScore === "GOOD" ? "d-none" : "") })
                        ),
                        React.createElement(
                            'h5',
                            null,
                            'Good 680-719'
                        )
                    ),
                    React.createElement(
                        Col,
                        { lg: 4, className: 'mb-4' },
                        React.createElement(
                            'div',
                            { className: 'overlay' },
                            React.createElement(Form.Check, {
                                type: 'radio',
                                id: 'fair',
                                name: 'CreditScore',
                                inline: true,
                                value: 'FAIR',
                                label: 'Fair',
                                'aria-label': 'Fair',
                                checked: CreditScore === "FAIR",
                                onChange: function onChange(e) {
                                    setCreditScore(e.target.value);
                                    dispatch(CreditScoreUpdate(e.target.value));
                                } }),
                            React.createElement('img', { src: imgFair,
                                alt: 'FAIR',
                                className: 'radImg2 rounded_circle radImg customShadow \n                                    ' + (CreditScore === "FAIR" ? "d-none" : "") })
                        ),
                        React.createElement(
                            'h5',
                            null,
                            'Fair 640-679'
                        )
                    ),
                    React.createElement(
                        Col,
                        { lg: 4, className: 'mb-2' },
                        React.createElement(
                            'div',
                            { className: 'overlay' },
                            React.createElement(Form.Check, {
                                type: 'radio',
                                inline: true,
                                id: 'Poor',
                                name: 'CreditScore',
                                value: 'POOR',
                                'aria-label': 'Poor',
                                label: 'Poor',
                                checked: CreditScore === "POOR",
                                onChange: function onChange(e) {
                                    setCreditScore(e.target.value);
                                    dispatch(CreditScoreUpdate(e.target.value));
                                } }),
                            React.createElement('img', { src: imgPoor,
                                alt: 'POOR',
                                className: 'radImg2 rounded_circle radImg customShadow \n                                    ' + (CreditScore === "POOR" ? "d-none" : "") })
                        ),
                        React.createElement(
                            'h5',
                            null,
                            'Poor <= 639'
                        )
                    )
                )
            )
        )
    );
}